import { isRecord } from '@ankhorage/utility/object';

/** Stable keyed entities whose collection identity is carried by the record key. */
export type EntityRegistry<
  TKey extends string,
  TValue,
  TIdentityField extends Extract<keyof TValue, string> = never,
> = Readonly<Record<TKey, TValue>> & Readonly<Record<never, TIdentityField>>;

/** Keyed configuration/property values whose key is part of the value's meaning. */
export type ValueMap<TKey extends string, TValue> = Readonly<Record<TKey, TValue>>;

export type SerializableSet<T extends string = string> = Readonly<Partial<Record<T, true>>>;

/*** Validate the canonical JSON-safe representation for unordered string membership. */
export function isSerializableSet(value: unknown): value is SerializableSet {
  return isRecord(value) && Object.values(value).every((member) => member === true);
}
